import { css } from 'styled-components';

const styles = css`
  .resend-code-text {
    font-size: ${(props) => props.theme.typography.fontSizes.fs14};
    font-weight: ${(props) => props.theme.fonts.fontWeight.semiBold};
    font-family: Nunito;
    text-align: ${(props) => (props.fromPlccICLogin ? 'left' : 'center')};
    .resent-code-cta {
      font-size: ${(props) => props.theme.typography.fontSizes.fs14};
      padding-left: 4px;
      color: ${(props) => props.theme.colorPalette.gray[900]};
    }
    button {
      background: none;
      border: none;
      cursor: pointer;
      text-decoration: underline;
      color: ${(props) => props.theme.colorPalette.blue.C900};
      outline: none;
    }
    .resend-it {
      font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
      color: #003761;
    }
  }
  .recaptcha_loginotp {
    ${(props) =>
      props.isLoginWithOTPEnabled &&
      `display: flex;
    flex-direction: column;
    align-items: center;`}
    .TextBox__error {
      ${(props) =>
        props.isLoginWithOTPEnabled &&
        `margin-top: 5px;
    margin-right: 100px;`}
    }
  }

  .otp-wrapper {
    margin: ${(props) => props.isLoginWithOTPEnabled && '0px 70px 0px 70px'};
    ${(props) => props.fromPlccICLogin && 'margin:0px;width:70%'};
  }

  .login-error {
    margin: ${(props) => props.isLoginWithOTPEnabled && '8px 0px 0px 5px;'};
  }
  @media (max-width: 850px) {
    .otp-wrapper {
      margin: ${(props) => props.isLoginWithOTPEnabled && '0px 50px 0px 50px;'};
    }
  }
  @media (max-width: 430px) {
    .otp-wrapper {
      margin: ${(props) =>
        props.variation === 'checkout' ? '0px 20px 0px 20px' : '0px 45px 0px 45px;'};
    }
  }
  .resent-code-link {
    font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
  }
  .plcc-border-style {
    width: 90%;
    border: solid 4px ${(props) => props.theme.colors.PROMO.PINK};
    height: 48px;
    box-shadow: 4px 4px ${(props) => props.theme.colors.DEFAULT_ACCENT_GYM},
      8px 8px ${(props) => props.theme.colors.PLCC_BACKGROUND};
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-left: auto;
    margin-right: auto;
    border-radius: 0px;
  }
  .plcc-border-style:hover {
    border: solid 4px ${(props) => props.theme.colors.PROMO.PINK};
  }
  .plcc-footer-cta-section {
    position: sticky;
    background-color: white;
    padding: 1px;
    bottom: 0px;
    width: 116%;
    margin-left: -35px;
    box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.12);
    margin-top: 46%;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      bottom: 34px;
      margin-left: -16px;
      margin-top: 48%;
      width: 108%;
    }
    @media ${(props) => props.theme.mediaQuery.medium} {
      width: 120%;
    }
  }
`;

export default styles;
